import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { encodeUtf8 } from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { ApiV6Service } from '@service/apiv6.service';
import { Tools } from '@service/tools';
import { lastValueFrom } from 'rxjs';
import { TreeService } from '@service/tree.service';
import { TreeNode } from 'primeng/api';
import { RightService } from '@service/right.service';
import { FormatRequestTools } from '@service/formatrequest.tools';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '@core/_services/loading.service';
import { TokenService } from '@core/_services/token.service';
import { DocumentService } from '@service/document.service';

@Component({
    selector: 'changedocs',
    templateUrl: 'changedocs.component.html',
    styleUrls: ['changedocs.component.scss'],
})
export class ChangeDocsComponent implements OnInit, OnChanges {
    @Input() public selectedDocs;
    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    @Output()
    public onClickChangeDoc: EventEmitter<any> = new EventEmitter();

    public fr: any;
    public error = false;
    public resultTree;
    public treeIndex;
    public selectedFile: TreeNode[] = [];
    public searchPath = '';
    private successList: any[];
    private failList: any[];
    public blockedTree: boolean = false;

    constructor(
        private api: ApiV6Service,
        public tools: Tools,
        protected _messageService: MessagesService,
        private rightService: RightService,
        private treeService: TreeService,
        private formatRequestTools: FormatRequestTools,
        private translate: TranslateService,
        private loadingService: LoadingService,
        private tokenService: TokenService,
        private documentService: DocumentService,
    ) {
        this.successList = new Array();
        this.failList = new Array();
    }

    public ngOnInit() {
        this.findAll();
    }

    public ngOnChanges() {}

    public endChangeDoc(aParam) {
        this.onClickChangeDoc.emit(aParam);
    }

    private async findAll() {
        let wRes: any;
        wRes = await this.treeService.getLoadTree();
        if (this.treeService.requestFailed === true) {
            return;
        }
        this.resultTree = wRes.base.result;
        this.treeIndex = this.treeService.updateTreeSearch(this.resultTree);
    }

    public nodeSelect(event) {
        this.searchPath = this.treeService.getPathClick(event.node, '');
        this.searchPath = encodeUtf8(this.searchPath);
    }

    public async nodeExpand(event) {
        let wRes;
        wRes = await this.treeService.nodeExpand(event, (callBack) => {
            this.blockedTree = callBack;
        });
    }   

    public onClickChange() {
        if (this.searchPath === '') {
            this._messageService.addWarnNoStick(this.translate.instant('Dir_Sel'));
        } else {
            this.prepareList(this.selectedDocs);
        }
    }

    private prepareList(aSelectedDocs) {
        let wDocList = new Array();
        wDocList = this.rightService.verifyRight(aSelectedDocs, 'TMov');
        if (wDocList.length === 0) {
            this._messageService.addErrorMsg(this.translate.instant('Move_Not'));
        } else {
            this.loadingService.initProgressBar(wDocList.length - (aSelectedDocs.length - wDocList.length), 2);
            this.changeDoc(wDocList, aSelectedDocs.length - wDocList.length);
        }
    }

    private async changeDoc(wDocList, aNbdoc) {
        this.successList = [];
        this.failList = [];
        for (const item of wDocList) {
            await this.doChangeDoc(item.doc_docid);
        }
        this.endChange(wDocList, aNbdoc);
    }

    private endChange(aDocList, aNbdoc) {
        this.loadingService.resetLoader();
        if (aDocList.length === this.successList.length) {
            if (aNbdoc === 0) {
                this._messageService.addSuccess(this.translate.instant('Move_OK'));
            } else {
                this._messageService.addWarn(this.translate.instant('Move_Right'));
            }
            this.endChangeDoc({
                docidList: JSON.stringify(this.successList),
            });
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Move_KO'));
        }
    }

    private async doChangeDoc(aCurrentDocId) {
        let wRes: boolean;
        wRes = false;
        // Verif lock
        this.documentService.setDocId(aCurrentDocId);
        wRes = await this.documentService.execVerifyCheckOut(this.tokenService.login);
        if (wRes === false) {
            return;
        }
        await this.execChangeDoc(aCurrentDocId);
    }

    private async execChangeDoc(aCurrentDocId) {
        let wRes: any;
        let wRequest: any;
        let wRoot = '';
        let wPath = '';
        wRes = false;
        let wRootPath = this.treeService.getRootPath(this.searchPath);
        this.formatRequestTools.clear(aCurrentDocId);
        wRequest = this.formatRequestTools.setChangeDoc(wRootPath.root, wRootPath.path, '');
        wRoot = wRootPath.root;
        wPath = wRootPath.path;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('changedoc', wRequest));
            this.successList.push({
                docId: aCurrentDocId,
                infos: {
                    root: wRoot,
                    path: wPath,
                    name: wRes.AtfNewName.length === 0 ? '' : wRes.AtfNewName,
                },
            });
        } catch (error) {
            this.failList.push(aCurrentDocId);
        }
    }

    public close(event) {
        this.visible = false;
        this.onClose.emit();
    }
}
